<template>
  <div
    :class="{ 'home-no-scroll': isProductConfigPage }"
    style="width: 100%;height: 100%;position: relative;overflow: auto;padding-bottom: 20px"
  >
    <div>
      <el-container :height="carouselheight">
        <el-header style="position: sticky;top:0;z-index:10">
          <head-top />
        </el-header>
        <div
          :class="{ 'home-content-no-scroll': isProductConfigPage }"
          style="width: 100%;height: 100%;overflow: auto;padding-bottom: 20px"
        >
          <el-main>
            <router-view />
          </el-main>
        </div>
        <!--<el-footer></el-footer>-->
      </el-container>
      <div v-if="isShowGuide" style="position: absolute;z-index: 999;width: 100%;height: 100%; top: 0;left: 0;">
        <swiper
          ref="guideSwiper"
          style="position: absolute;z-index: 999;width: 100%;height: 100%; top: 0;left: 0;"
          :options="swiperOption"
        >
          <!-- slides -->
          <swiper-slide>
            <img
              style="width: 100%; height: 100%;"
              src="../assets/guide/changjing-01.png"
              @click="nextGuideStep"
              alt="err"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              style="width: 100%; height: 100%;"
              src="../assets/guide/changjing-02.png"
              @click="nextGuideStep"
              alt="err"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              style="width: 100%; height: 100%;"
              src="../assets/guide/changjing-03.png"
              @click="nextGuideStep"
              alt="err"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              style="width: 100%; height: 100%;"
              src="../assets/guide/changjing-04.png"
              @click="closeGuide"
              alt="err"
            >
          </swiper-slide>
          <div class="swiper-pagination swiper-pagination-white" slot="pagination" />
        </swiper>
        <a href="#" @click="closeGuide">
          <img src="../assets/guide/close.png" style="position: absolute;z-index: 999;right: 30px; top: 34px;" alt="err"></a>
      </div>
      <div class="modal" v-if="isShowVideoGuide">
        <div class="floater">
          <a href="#" @click="closeGuide">
            <img src="../assets/guide/close.png" style="position: absolute;z-index: 999;right: 30px; top: 34px;" alt="err">
          </a>
        </div>
        <div style="position: absolute;left: 50%;top: 50%;margin-left:-425px;margin-top:-240px;">
          <video-player
            ref="videoPlayer"
            @play="onPlayerPlay($event)"
            :options="playerOptions"
            :playsinline="true"
          />
        </div>
      </div>
    </div>
    <div class="updating">
      <el-dialog
        :visible.sync="versionUpdating"
        width="30%"
        :show-close="false"
        :close-on-click-modal="false"
      >
        <div class="updating-background">
          <img src="../assets/updating.png" alt="err">
        </div>
        <div class="title">发布新版本</div>
        <template v-for="(item,index) in lastestContentData">
          <div v-if="index < 1" :key="index" class="version">
            V {{ item.versionCode }}
          </div>
        </template>
        <div class="content">
          <template v-for="(item,index) in lastestContentData">
            <div v-if="index < 1" :key="index" class="title">
              {{ item.updateTime }}更新内容:
            </div>
          </template>
          <div v-for="(item,j) in lastestContentData" :key="j" class="main-content">
            <div>{{ j+1 }}、{{ item.versionDescribe }}</div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button style="cursor:pointer" type="primary" @click="getVersionUpdating">我知道了</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script type="es6">
// import ydRollnoticeItem from './components/rollnotice-item';
// import ydRollnotice from './components/rollnotice';
import API from '../api';
import Cookies from 'js-cookie';
import evenBus from '../utils/eventBus';
import HeadTop from './components/HeadTop.vue';
import 'video.js/dist/video-js.css';
import { videoPlayer } from 'vue-video-player';
export default {
  data () {
    return {
      lastestContentData: [],
      versionUpdating: false,
      isShowVideoGuide: false,
      playerOptions: {
        // videojs options
        muted: false,
        language: 'zh',
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [{
          type: 'video/mp4',
          // src: 'http://wpcuat.ruijienetworks.com/static/video/videoGuide.mp4'
          src: require('../../static/video/videoGuide.mp4')
        }],
        height: '480',
        responsive: true,
        poster: '/static/images/author.jpg'
      },
      isShowGuide: false,
      listData: [],
      isLogin: false,
      isSalerole: false,
      pageWidth: 0,
      swiperOption: {
        // spaceBetween: 30,
        // effect: 'cube',
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        mousewheel: true,
        preventClicks: false// 默认true
      }
    };
  },
  components: {
    HeadTop,
    videoPlayer,
    // ydRollnoticeItem,
    // ydRollnotice,
  },
  computed: {
    player () {
      return this.$refs.videoPlayer.player;
    },
    carouselheight () {
      let height = 0;
      let rd = 598 / 1920;
      height = this.pageWidth * rd;
      return height + 'px';
    },
    isProductConfigPage () {
      return ['AdditionProduct/add', 'AddedProduct/added'].includes(this.$route.name);
    },
    swiper () {
      return this.$refs.guideSwiper.swiper;
    }
  },
  methods: {
    onPlayerPlay (player) {
      let playButton = document.getElementsByClassName('vjs-big-play-button');
      if (playButton.length > 0) {
        playButton[0].setAttribute('style', 'display:none');
      }
    },
    nextGuideStep () {
      let swiper = this.$refs.guideSwiper.swiper;
      if (swiper) {
        swiper.slideNext();
      }
    },
    closeGuide () {
      this.isShowGuide = false;
      if (this.$refs.videoPlayer && this.$refs.videoPlayer.player && this.$refs.videoPlayer.player !== undefined) {
        this.isShowVideoGuide = false;
        this.playerOptions.sources = [{
          type: 'video/mp4',
          src: 'http://wpcuat.ruijienetworks.com/static/video/videoGuide.mp4'
        }];
        // this.$refs.videoPlayer.player.show();
        // this.$refs.videoPlayer.player.reset();
      }
      API.postUserGuide()
        .then(result => {
        })
        .catch(e => {
          console.error('e', e);
        });
    },
    init () {
      let userCookie = Cookies.get('ruijienetworks_user_credentials');
      let userCookie2 = Cookies.get('ruijienetworks_sso_internal_certificate');
      if (userCookie2 || userCookie) {
        this.isLogin = true;
      }
    },
    goLogin () {
      let backURL = window.location.href;
      // window.location.href = 'https://www.ruijienetworks.com/login.aspx?r=' + backURL;
      if(window._env_.NODE_ENV === "pro") {
 window.location.href = `https://account.ruijie.com?r=${encodeURIComponent(
      backURL
    )}`;
      } else {
         window.location.href = `https://account-uat.ruijie.com?r=${encodeURIComponent(
      backURL
    )}`;
      }
     
    },
    downfile () {
      if (this.isLogin) {
        document.getElementById('downfiles').click();
      } else {
        this.goLogin();
      }
    },
    getLatestContent () {
      API.getLatestContent().then((res) => {
        if (res.data.status === '200') {
          this.lastestContentData = res.data.data;
          this.versionUpdating = true;
        }
      }).catch(() => {

      });
    },
    getVersionUpdating () {
      API.setVersionSwitch().then((res) => {
        if (res.data.status === '200') {
          this.versionUpdating = false;
          // this.versionUpdating=true;
        }
      }).catch(() => {

      });
    },
    closeHistory () {
      // this.isShowHistory == false;
    }
  },
  mounted () {
    this.pageWidth = document.body.offsetWidth;
    window.onresize = () => {
      this.pageWidth = document.body.offsetWidth;
    };
    this.init();
    evenBus.$on('roleCookie', _ => {
      this.checkrole();
    });
    // TODO
    evenBus.$on('postUserGuide', userData => {
      if (userData != null) {
        if (userData.guideInfo == null || !userData.guideInfo.isGuided) {
          this.isShowGuide = true;
        }
      }
    });

    evenBus.$on('getVersionUpdating', userData => {
      if (userData != null) {
        if (userData.guideInfo && userData.guideInfo.versionSwitch) {
          this.getLatestContent();
        } else {
          this.versionUpdating = false;
          // this.versionUpdating = true;
        }
      }
    });
    evenBus.$on('postVideoUserGuide', () => {
      this.isShowVideoGuide = true;
    });
  },
  destroy () {
    evenBus.$off('postUserGuide');
    evenBus.$off('postVideoUserGuide');
    evenBus.$off('getVersionUpdating');
    window.onresize = null;
  }
};
</script>
<style rel="stylesheet/scss" lang="scss">
  .home-no-scroll,
  .home-content-no-scroll {
    overflow: hidden !important;
  }

  @import "../styles/variables";
  html {font-size: 62.5%;}
  *{
    font-family: '微软雅黑';
  }
  .video-js .vjs-big-play-button {
    font-size: 3em;
    line-height: 1.5em;
    height: 1.5em;
    width: 3em;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 0;
    margin: auto;
    cursor: pointer;
    opacity: 1;
    border: 0.06666em solid #fff;
    background-color: #2B333F;
    background-color: rgba(43, 51, 63, 0.7);
    border-radius: 0.3em;
    -webkit-transition: all 0.4s;
    transition: all 0.4s;
  }

  .modal{
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1000;
    background-color: rgba(0,0,0,0.5);
  }

  .f-blue{
    color:#34A3C9;
  }
  .f-black{
    color: #000000;
  }
  .floater {
    float:left;
    height:20%;
  }
  .el-header {
    background-color: white;
    color: #333;
    line-height: 6rem;
    padding: 0px;
  }
  .el-footer {
    background-color: white;
    color: #333;
    line-height: 6rem;
  }
  .el-main {
    margin: 0 auto;
    overflow-y: auto;
    overflow-x: hidden;
    width: 100%;
    text-align: center;
    padding-top: 0!important;
    padding-bottom: 0!important;
    box-sizing: border-box;

  }

  .menucontent {
    width: 1200px;
    margin: 0 auto;
    overflow-y: auto;
    overflow-x: hidden;
    padding-top: $headerheight;
    padding-bottom: $bottomheight;
    transition: height 0.4s;
    -moz-transition: height 0.4s; /* Firefox 4 */
    -webkit-transition: height 0.4s; /* Safari 和 Chrome */
    -o-transition: height 0.4s; /* Opera */
    .ruijie-menu {
      width: 200px;
      background: #fff;
      bottom: $bottomheight;
      left: 0;
      z-index: 100;
      float: left;
      transition: width 0.4s;
      -moz-transition: width 0.4s; /* Firefox 4 */
      -webkit-transition: width 0.4s; /* Safari 和 Chrome */
      -o-transition: width 0.4s; /* Opera */
      border: 1px solid #ebebeb;
      border-top: none;
      .menuborder {
        position: fixed;
        width: 1px;
        height: 100%;
        background: #ebebeb;
        left: 200px;
        top: 0;
        transition: left 0.4s;
        -moz-transition: left 0.4s; /* Firefox 4 */
        -webkit-transition: left 0.4s; /* Safari 和 Chrome */
        -o-transition: left 0.4s; /* Opera */
      }
    }
  }

  .el-pager li.active {
    color: #36BADE;
  }
  .el-select-dropdown__item.selected {
    color: #36BADE;
    font-weight: 700;
  }

  .el-button--text {
    color: #36BADE;

  }

  .el-message{
    top:10rem;
  }
  .el-dialog__footer{
    text-align: center;
  }

  .updating .el-dialog__header{
    display: none;
  }
  .updating .el-dialog{
    position: relative;
    min-height: 250px;
    z-index: -2;
  }

  .updating .el-dialog__body{
    padding: 0 10px 30px 10px;
  }

  .updating .title{
    font-weight: bold;
    font-size: 26px;
    color: #ffffff;
  }

  .updating .version{
    color: #36BADE;
    font-size: 14px;
    font-weight: bold;
    background: #ffffff;
    width: 70px;
    text-align: center;
    border-radius: 5px;
    margin-top: 2px;
  }

  .updating .content{
    margin-top: 120px;
  }

  .updating .content .title{
    font-weight: bold;
    color: #333333;
    margin-left: 60px;
    margin-right: 60px;
    margin-bottom: 10px;
    font-size: 18px;
  }

  .updating .content .main-content{
    margin-left: 60px;
    margin-right: 60px;
    margin-top: 4px;
  }
  .updating .updating-background{
    width: 100%;
    height: 200px;
    position: absolute;
    left: 0;
    top: -40px;
    z-index: -1;
  }
  .updating .updating-background img{
    width: 100%;

  }
  @media screen and (max-width: 1680px)  {
    .updating .content{
      margin-top: 90px;
    }
  }

  @media screen and (max-width: 1366px)  {
    .updating .content{
      margin-top: 60px;
    }
    .updating .content .title{
      margin-left: 20px;
      margin-right: 20px;
      font-size: 16px;
    }

    .updating .content .main-content{
      margin-left: 20px;
      margin-right: 20px;
    }
  }

</style>
